export enum PeriodListTableColumns {
  PERIOD_NAME = 'Period Name',
  START_TIME = 'Start Time',
  END_TIME = 'End Time',
  REF_CODE = 'Ref. Code',
  EXT_CODE = 'Ext. Code',
  ACTIONS = 'Actions',
}
